<template>
  <div></div>
</template>

<script>
import { get } from "../helper/get";

export default {
  name: "attribute-updater",

  inject: {
    itemId: {
      default: null,
    },
  },

  props: ["crossitems"],

  computed: {
    currentVariation() {
      return this.$store.getters[`${this.itemId}/currentItemVariation`];
    },
    attributes() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
    },
  },

  mounted() {
    this.updateAttr();
    this.findPrices();
    document.addEventListener("onVariationChanged", this.updateAttr);
  },

  methods: {
    updateAttr() {
      const attributes = this.attributes || [];
      const attributeString = attributes.length
          ? attributes[0].values.map(val => val.name).join(",")
          : "";

      const variation = this.currentVariation;
      const varProps = variation?.variationProperties || [];
      const existingStr = varProps.find(prop => prop.id === 297)?.properties?.[0]?.values?.value || "";
      const colorsProp = varProps.find(prop => prop.id === 301)?.properties?.[0]?.values?.value;
      const colors = colorsProp ? JSON.parse(colorsProp) : [];
      const colorCount = colors.length;
      const colorTimestamp = colors.length ? colors[0].lastUpdated : 0;
      const varRelatedUpdated = Math.floor(new Date(variation.variation.relatedUpdatedAt).getTime() / 1000);

      const data = {
        itemId: variation.variation.id,
        attr: attributeString,
      };

      if (attributeString !== existingStr) {
        $.ajax({
          type: "POST",
          url: "/update/item/",
          data,
          dataType: "json",
          success: () => {},
          error: () => {},
        });
      }

      if (!colors.length || varRelatedUpdated > colorTimestamp + 60 || colorCount !== this.crossitems.length) {
        $.ajax({
          type: "GET",
          url: `/farbwerte/setColorsForVar/${variation.variation.id}/`,
          success: () => {},
          error: () => {},
        });
      }
    },
    findPrices()
    {
      const item = this.currentVariation.item.id;
      let data = {
        "itemId":item
      }
      $.ajax({
        type: "POST",
        url: "/updata/",
        data:data,
        dataType: "json",
        success: () => {},
        error: () => {},
      });
    }
  },
};
</script>
